import React, { useState } from 'react';
import { Box, Button, Grid, TextField, Typography } from '@mui/material';
import { Upload, LockReset, Save } from '@mui/icons-material';
import { Avatar } from '@mui/material';
import { AdminProfileProps } from './type';
import { COLORS_ADMIN_PAGE, SIZES_PAGE } from '../conf/constants';
import { validatePhoneNumber } from '../utils/validators';

const AdminProfile: React.FC<AdminProfileProps> = ({
  selectedAdmin,
  formData,
  handleFormChange,
  handleFormSubmit,
  handleUploadAvatar,
  handleChangePassword,
}) => {
  const [phoneError, setPhoneError] = useState<string | null>(null);

  if (!selectedAdmin) return <Typography>No admin selected</Typography>;

  const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    handleFormChange(e);
    const { error } = validatePhoneNumber(value);
    setPhoneError(error);
  };

  const handleSubmit = () => {
    if (validatePhoneNumber(formData.phoneNumber || '')) {
      handleFormSubmit();
    }
  };

  return (
    <>
      <Typography variant="h4" gutterBottom sx={{ color: COLORS_ADMIN_PAGE.TEXT_SECONDARY }}>
        Administrator User Profile
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={3}>
          <Box sx={{ textAlign: 'center' }}>
            <Avatar
              src={selectedAdmin.profileImageUrl || '/default-avatar.png'}
              sx={{ width: SIZES_PAGE.AVATAR_SIZE, height: SIZES_PAGE.AVATAR_SIZE, mx: 'auto', mb: 2 }}
            />
            <Button
              variant="contained"
              onClick={handleUploadAvatar}
              startIcon={<Upload />}
              sx={{ bgcolor: COLORS_ADMIN_PAGE.PRIMARY, mb: 2, width: '100%', justifyContent: 'flex-start' }}
            >
              UPLOAD AVATAR PHOTO
            </Button>
            <Button
              variant="contained"
              onClick={handleChangePassword}
              startIcon={<LockReset />}
              sx={{ bgcolor: COLORS_ADMIN_PAGE.PRIMARY, mb: 2, width: '100%', justifyContent: 'flex-start' }}
            >
              CHANGE PASSWORD
            </Button>
            <Button
              variant="contained"
              onClick={handleSubmit}
              startIcon={<Save />}
              disabled={!!phoneError}
              sx={{ bgcolor: COLORS_ADMIN_PAGE.PRIMARY, mb: 2, width: '100%', justifyContent: 'flex-start' }}
            >
              SAVE CHANGES
            </Button>
          </Box>
        </Grid>
        <Grid item xs={9}>
          <Typography variant="subtitle1" gutterBottom sx={{ color: COLORS_ADMIN_PAGE.TEXT_SECONDARY, mb: -1 }}>
            Name
          </Typography>
          <TextField
            label="First Name"
            name="firstName"
            value={formData.firstName}
            onChange={handleFormChange}
            fullWidth
            sx={{ mb: 2 }}
          />
          <TextField
            label="Middle Name"
            name="middleName"
            value={formData.middleName || ''}
            onChange={handleFormChange}
            fullWidth
            sx={{ mb: 2 }}
          />
          <TextField
            label="Last Name"
            name="lastName"
            value={formData.lastName}
            onChange={handleFormChange}
            fullWidth
            sx={{ mb: 2 }}
          />

          <Typography variant="subtitle1" gutterBottom sx={{ color: COLORS_ADMIN_PAGE.TEXT_SECONDARY, mb: -1 }}>
            Phone
          </Typography>
          <TextField
            label="Phone Number"
            name="phoneNumber"
            value={formData.phoneNumber || ''}
            onChange={handlePhoneChange}
            fullWidth
            sx={{ mb: 2 }}
            error={!!phoneError}
            helperText={phoneError}
          />

          <Typography variant="subtitle1" gutterBottom sx={{ color: COLORS_ADMIN_PAGE.TEXT_SECONDARY, mb: -1 }}>
            Account
          </Typography>
          <TextField
            label="Username"
            name="username"
            value={formData.username}
            fullWidth
            disabled
            InputProps={{ readOnly: true }}
            sx={{ mb: 2 }}
          />
          <TextField
            label="Email"
            name="email"
            value={formData.email}
            fullWidth
            disabled
            InputProps={{ readOnly: true }}
            sx={{ mb: 2 }}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default AdminProfile;